<template>
  <div class="call_log">
    <a-table
      :columns="columns"
      :data-source="tableData"
      :pagination="false"
      :rowKey="(record, index) => index"
      :loading="loading"
      :scroll="{ y: 700 }"
    >
      <template #callerType="{ record }">
        <div class="service_person">
          <roles :solerType="record.callerType" />
          <span>{{ record.callerName }}</span>
          <auth-img :src="callIcon" />
        </div>
      </template>
      <template #calleeName="{ record }">
        <div class="service_person">
          <roles :solerType="record.calleeType" />
          <span>{{ record.calleeName }}</span>
        </div>
      </template>
      <!-- 电话时长 -->
      <template #duration="{ record, index }">
        <template v-if="record.duration">
          <div @click="play(index)" class="call_duration" v-if="!record.isPlay">
            <auth-img :src="playIcon" />
            <span>{{ renderTime(record.duration) }}</span>
          </div>
          <div v-if="record.isPlay">
            <audio :src="record.audioUrl" controls ref="audioRef"></audio>
          </div>
        </template>
        <template v-else>--</template>
      </template>
      <!-- 通话状态 -->
      <template #endStatusDesc="{ record }">
        <span :class="{ red: record.errorStatusFlag }">
          {{ record.endStatusDesc || '--' }}
        </span>
      </template>
      <!-- <template #call="{ record }">
        <a v-if="record.buttonDisplay" @click="call(record)">拨打电话</a>
        <span v-else>--</span>
      </template> -->
    </a-table>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, defineProps } from 'vue'
import { getCdrList } from '@/api/chat'
import { renderTime } from '@/utils'
import playIcon from '@/assets/img/chat/playIcon.png'
import callIcon from '@/assets/img/chat/callIcon.png'

const props = defineProps({
  cdrIds: {
    type: Array,
    default: () => []
  }
})

const audioRef = ref(null)

// 播放录音
function play(index) {
  console.log(index)
  tableData.value.forEach(it => (it.isPlay = false))
  tableData.value[index].isPlay = true
  nextTick(() => {
    audioRef.value.play()
  })
}

const tableData = ref([])
const loading = ref(false)

onMounted(() => {
  getData()
})

function getData() {
  loading.value = true
  const query = {
    pageSize: 99,
    pageNo: 1,
    cdrIds: props.cdrIds
  }
  getCdrList(query)
    .then(res => {
      const { list } = res
      tableData.value = list
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}

// const call = record => {
//   const list = ['', '患者', '医生', 'BD', '医助', '医生学生']
//   Modal.confirm({
//     centered: true,
//     title: '确定拨打电话',
//     icon: createVNode(ExclamationCircleOutlined),
//     content: `确定给${list[record.callerType]}-${record.callerName}拨打电话吗？`,
//     okText: '拨打',
//     cancelText: '取消',
//     onOk: () => {
//       const params = {
//         calleeType: record.callerType,
//         calleeUcUserId: record.callerUcUserId,
//         doctorId: record.doctorId,
//         workOrderIds: record.workOrderIds || []
//       }
//       callOut(params, {
//         userType: list[record.callerType],
//         name: record.callerName
//         // header: ''
//       })
//     }
//   })
// }

const columns = [
  {
    title: '呼出人',
    dataIndex: 'callerType',
    key: 'callerType',
    align: 'left',
    slots: {
      customRender: 'callerType'
    }
  },
  {
    title: '接听人',
    dataIndex: 'calleeName',
    key: 'calleeName',
    align: 'left',
    slots: {
      customRender: 'calleeName'
    }
  },
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    align: 'left'
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'left'
  },
  {
    title: '电话时长',
    dataIndex: 'duration',
    key: 'duration',
    align: 'left',
    slots: {
      customRender: 'duration'
    }
  },
  {
    title: '通话状态',
    dataIndex: 'endStatusDesc',
    key: 'endStatusDesc',
    align: 'left',
    slots: {
      customRender: 'endStatusDesc'
    }
  },
  {
    title: '未接来电处理标记',
    dataIndex: 'processingFlag',
    key: 'processingFlag',
    align: 'left',
    slots: {
      customRender: 'processingFlag'
    }
  }
  // {
  //   title: '关联工单',
  //   dataIndex: 'action',
  //   key: 'action',
  //   align: 'left',
  //   slots: {
  //     customRender: 'action'
  //   }
  // }
  // {
  //   title: '操作',
  //   dataIndex: 'call',
  //   key: 'call',
  //   align: 'left',
  //   slots: {
  //     customRender: 'call'
  //   }
  // }
]
</script>

<style lang="scss">
.call_log {
  padding: 20px;
  .red {
    color: #f5222d;
  }
  .header {
    padding: 10px 20px;
    background-color: #ffffff;
    margin-bottom: 20px;
  }
  .service_person {
    img {
      margin-left: 8px;
      width: 16px;
      height: 16px;
    }
  }
  .call_duration {
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      margin-right: 12px;
    }
  }
  .pagination {
    margin-top: 16px;
  }
}
</style>
